:host {
  .header {
    position: relative;
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px 0;
    align-items: center;
    z-index: 10000;
    border-radius: 8px;
    background: linear-gradient(180deg, #2d6ae0 -381.46%, #1d50d5 100%), #ffffff;
    &.background-pro {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #0c3191 100%), #ffffff;
    }
    &.background-business {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #3a3652 100%), #ffffff;
    }

    &.background-transparent {
      background: transparent;
    }

    &--separator {
      position: absolute;
      width: 750px;
      height: 50px;
      left: -75px;
      border-radius: 0 0 50% 50%;
      bottom: -10px;
      z-index: 1;
      box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.04);

      background: linear-gradient(180deg, #2d6ae0 -381.46%, #1d50d5 50%), transparent;
      &.background-pro {
        background: linear-gradient(180deg, #2d6ae0 -381.46%, #0c3191 50%), transparent;
      }
      &.background-business {
        background: linear-gradient(180deg, #2d6ae0 -381.46%, #3a3652 50%), transparent;
      }

      &.background-transparent {
        background: transparent;
        box-shadow: none;
      }
    }

    .premium-icon {
      position: relative;
      z-index: 3;
      cursor: pointer;
    }

    &__user {
      position: relative;
      margin: 0 auto;
      left: -20px;
      z-index: 3;

      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #0098ff;
        text-decoration: none;
        font-size: 12px;
      }
    }

    &__close,
    &__refresh {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 20px;
      z-index: 10;

      img {
        width: 14px;
        height: 14px;
        object-fit: contain;
      }
    }

    &__refresh {
      color: #fff;
      right: 50px;

      img {
        filter: invert(66%) sepia(83%) saturate(2738%) hue-rotate(315deg) brightness(115%)
          contrast(92%);
        filter: var(--icon-salmon);
      }
    }
  }

  @media (max-width: 768px) {
    .header {
      &--separator {
        width: 200%;
        left: -50%;
      }
    }
  }
}
